import { DocumentService } from "./DocumentService";

export class StockTakingsService extends DocumentService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        delete clonedObject.id;
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}